import React, { useState, useEffect, useRef } from 'react';
import { Drawer, Tabs, Card, Row, Col, Button, Space, Table, message, Tag, Spin, Empty, Result, Dropdown, InputNumber, Input, Alert, Select, DatePicker, Checkbox, Avatar, Upload } from 'antd';
import { TeamOutlined, FileTextOutlined, CheckCircleOutlined, CloseCircleOutlined, UploadOutlined, UserOutlined, FileOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { darBajaEmpleado, getAll as getAllEmpleados, getEmpleadoById, getMotivosBajaList, getNominaRegimenSalarialList, getTipoContratoList, recontratarEmpleado, editarEmpleado, getOdooHorarioList, actualizarFotoEmpleado } from '../../../../apis/OdooApi';
import { getByIdEmpleado } from '../../../../apis/OdooMovimientoEmpleadoApi';
import { aplicarActualizacionSalarialEmpleado, previewActualizacionSalarialEmpleado } from '../../../../apis/CalculoIntegradoApi';
import { getList as getAllPeriodos, getDetailsById as getDetallesPeriodo } from '../../../../apis/PeriodosApi';
import { getList as getAnaliticas } from '../../../../apis/OdooAnaliticaApi';
import { getList as getPuestos } from '../../../../apis/OdooPuestoApi';
import { getAll as getSupervisores } from '../../../../apis/SupervisoresApi';
import { getList as getDepartamentos } from '../../../../apis/OdooDepartamentoApi';
import { getList as getIntegraciones } from '../../../../apis/IntegracionApi';
import { getList as getAreasTrabajo } from '../../../../apis/AreasTrabajoApi';
import { getBancosOdoo } from '../../../../apis/BancosApi';
import { uploadDocumento, getDocumentosByEmpleado, downloadDocumento, deleteDocumento } from '../../../../apis/DocumentoEmpleadoApi';
import { getList as getRegistroPatronalList } from '../../../../apis/RegistroPatronalApi';
import ChangePassword from './ChangePassword';

const { TextArea } = Input;

const EmpleadoDetail = ({ title, id, open, finish, employeesViewFilter = 'active' }) => {
  const [empleado, setEmpleado] = useState(null);
  const [kardex, setKardex] = useState([]);
  const [supervisor, setSupervisor] = useState(null);
  const [directReports, setDirectReports] = useState([]);
  const [activeTab, setActiveTab] = useState('info');
  const [documentos, setDocumentos] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [salaryPreview, setSalaryPreview] = useState(null);
  const [salaryPreviewError, setSalaryPreviewError] = useState(null);
  const [salaryForm, setSalaryForm] = useState({
    nomina_daily_salary: 0,
    nomina_monthly_salary: 0,
    nomina_variable_amount: 0,
    nomina_fixed_amount: 0,
    comentario: '',
    fecha_aplicacion: dayjs(),
  });
  const [loading, setLoading] = useState(false);
  const [loadingKardex, setLoadingKardex] = useState(false);
  const [loadingSalaryPreview, setLoadingSalaryPreview] = useState(false);
  const [loadingApplySalary, setLoadingApplySalary] = useState(false);
  const [motivosBaja, setMotivosBaja] = useState([]);
  const [regimenesSalariales, setRegimenesSalariales] = useState([]);
  const [tiposContrato, setTiposContrato] = useState([]);
   const [tipoPeriodo, setTipoPeriodo] = useState([]);
   const [periodoDetalles, setPeriodoDetalles] = useState([]);
   const [loadingPeriodoDetalles, setLoadingPeriodoDetalles] = useState(false);
   const [registroPatronalList, setRegistroPatronalList] = useState([]);
  const [selectedMotivoBaja, setSelectedMotivoBaja] = useState(null);
  const [deactivateForm, setDeactivateForm] = useState({
    nomina_leaving_date: null,
    nomina_contract_end_date: null,
    nomina_last_period_type: null,
    nomina_last_year: null,
    nomina_last_period: null,
    nomina_can_reenter: false,
    nomina_leaving_comment: null,
  });
  const [loadingMotivosBaja, setLoadingMotivosBaja] = useState(false);
  const [loadingApplyBaja, setLoadingApplyBaja] = useState(false);
  const [rehireForm, setRehireForm] = useState({
    nomina_contract_start_date: null,
    nomina_contract_end_date: null,
    nomina_contract_type_id: null,
    nomina_integration_id: null,
    nomina_daily_salary: 0,
    nomina_monthly_salary: 0,
    nomina_variable_amount: 0,
    nomina_fixed_amount: 0,
    department_id: null,
    periodo_id: null,
    job_id: null,
    nomina_workarea_id: null,
    comentario: '',
  });
  const [loadingApplyRehire, setLoadingApplyRehire] = useState(false);
  
  const [editForm, setEditForm] = useState({
    nomina_name: '',
    nomina_first_last_name: '',
    nomina_second_last_name: '',
    work_email: '',
    work_phone: '',
    private_street: '',
    private_street2: '',
    private_city: '',
    job_id: null,
    analitica_id: null,
    odoo_parent_id: null,
    resource_calendar_id: null,
    nomina_rfc: '',
    nomina_curp: '',
    nomina_imss_number: '',
    nomina_employee_number: '',
    department_id: null,
    nomina_workarea_id: null,
    nomina_entry_date: null,
    nomina_seniority_date: null,
    nomina_contract_type_id: null,
    nomina_contract_start_date: null,
    nomina_contract_end_date: null,
    nomina_integration_id: null,
    periodo_id: null,
    nomina_employee_registration_key: '',
    nomina_zip_code: '',
    banco_id: null,
    nomina_wage_scheme: '',
    nomina_need_timesheets: false,
  });
  const [loadingApplyEdit, setLoadingApplyEdit] = useState(false);
  const [puestos, setPuestos] = useState([]);
  const [supervisores, setSupervisores] = useState([]);
  const supervisoresRawRef = useRef([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [areasTrabajo, setAreasTrabajo] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [integraciones, setIntegraciones] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [analiticas, setAnaliticas] = useState([]);
  const [fotoUploading, setFotoUploading] = useState(false);

  const getDefaultDeactivateForm = (emp = null) => ({
    nomina_leaving_date: null,
    nomina_contract_end_date: null,
    nomina_last_period_type: emp?.nomina_last_period_type || null,
    nomina_last_year: emp?.nomina_last_year || null,
    nomina_last_period: emp?.nomina_last_period || null,
    nomina_can_reenter: false,
    nomina_leaving_comment: null,
  });

  const getDefaultRehireForm = (emp = null) => ({
    nomina_contract_start_date: null,
    nomina_contract_end_date: null,
    nomina_contract_type_id: emp?.nomina_contract_type_id !== null && emp?.nomina_contract_type_id !== undefined
      ? Number(emp.nomina_contract_type_id)
      : null,
    nomina_integration_id: emp?.nomina_integration_id || null,
    nomina_daily_salary: Number(emp?.nomina_daily_salary || 0),
    nomina_monthly_salary: Number(emp?.nomina_monthly_salary || 0),
    nomina_variable_amount: Number(emp?.nomina_variable_amount || 0),
    nomina_fixed_amount: Number(emp?.nomina_fixed_amount || 0),
    department_id: emp?.department_id || null,
    periodo_id: emp?.periodo_id || null,
    job_id: emp?.job_id || null,
    nomina_workarea_id: emp?.nomina_workarea_id || null,
    comentario: '',
  });

  const getDefaultEditForm = (emp) => {
    if (!emp) {
      return {
        nomina_name: '',
        nomina_first_last_name: '',
        nomina_second_last_name: '',
        work_email: '',
        work_phone: '',
        private_street: '',
        private_street2: '',
        private_city: '',
        job_id: null,
        analitica_id: null,
        odoo_parent_id: null,
        resource_calendar_id: null,
        nomina_rfc: '',
        nomina_curp: '',
        nomina_imss_number: '',
        nomina_employee_number: '',
        department_id: null,
        nomina_workarea_id: null,
        nomina_entry_date: null,
        nomina_seniority_date: null,
        nomina_contract_type_id: null,
        nomina_contract_start_date: null,
        nomina_contract_end_date: null,
        nomina_integration_id: null,
        periodo_id: null,
        nomina_employee_registration_key: '',
        nomina_zip_code: '',
        banco_id: null,
        nomina_wage_scheme: '',
        nomina_need_timesheets: false,
      };
    }
    return {
      nomina_name: emp.nomina_name || '',
      nomina_first_last_name: emp.nomina_first_last_name || '',
      nomina_second_last_name: emp.nomina_second_last_name || '',
      work_email: emp.work_email || '',
      work_phone: emp.work_phone || '',
      private_street: emp.private_street || '',
      private_street2: emp.private_street2 || '',
      private_city: emp.private_city || '',
      job_id: emp.job_id || null,
      analitica_id: emp.analitica_id || null,
      odoo_parent_id: emp.odoo_parent_id || null,
      resource_calendar_id: emp.resource_calendar_id || null,
      nomina_rfc: emp.nomina_rfc || '',
      nomina_curp: emp.nomina_curp || '',
      nomina_imss_number: emp.nomina_imss_number || '',
      nomina_employee_number: emp.nomina_employee_number || '',
      department_id: emp.department_id || null,
      nomina_workarea_id: emp.nomina_workarea_id || null,
      nomina_entry_date: emp.nomina_entry_date ? dayjs(emp.nomina_entry_date) : null,
      nomina_seniority_date: emp.nomina_seniority_date ? dayjs(emp.nomina_seniority_date) : null,
      nomina_contract_type_id: emp.nomina_contract_type_id !== null && emp.nomina_contract_type_id !== undefined
        ? Number(emp.nomina_contract_type_id)
        : null,
      nomina_contract_start_date: emp.nomina_contract_start_date ? dayjs(emp.nomina_contract_start_date) : null,
      nomina_contract_end_date: emp.nomina_contract_end_date ? dayjs(emp.nomina_contract_end_date) : null,
      nomina_integration_id: emp.nomina_integration_id || null,
      periodo_id: emp.periodo_id || null,
      nomina_employee_registration_key: emp.nomina_employee_registration_key || emp.nomina_employer_registration_key || '',
      nomina_zip_code: emp.nomina_zip_code || '',
      banco_id: emp.banco_id || null,
      nomina_wage_scheme: emp.nomina_wage_scheme || '',
      nomina_need_timesheets: Boolean(emp.nomina_need_timesheets),
    };
  };

  useEffect(() => {
    if (!open || !id) return;
    (async () => {
      setLoading(true);
      await loadRegimenesSalariales();
      await loadTiposContrato();
      await loadCatalogosFormulario();
      await loadEmpleadoData();
      await loadKardexData();
      await loadDocumentos();
      setLoading(false);
    })();
  }, [id, open]);

  const loadRegimenesSalariales = async () => {
    try {
      const response = await getNominaRegimenSalarialList();
      if (response?.ok) {
        setRegimenesSalariales(response.payload || []);
      } else {
        setRegimenesSalariales([]);
      }
    } catch (error) {
      setRegimenesSalariales([]);
    }
  };

  const loadTiposContrato = async () => {
    try {
      const response = await getTipoContratoList();
      if (response?.ok) {
        setTiposContrato(response.payload || []);
      } else {
        setTiposContrato([]);
      }
    } catch (error) {
      setTiposContrato([]);
    }
  };

  const loadCatalogosFormulario = async () => {
    try {
      const [resPuestos, resSupervisores, resDepartamentos, resAreas, resBancos, resIntegraciones, resAnaliticas, resHorarios, resPeriodos, resRegistro] = await Promise.all([
        getPuestos(),
        getSupervisores(),
        getDepartamentos(),
        getAreasTrabajo(),
        getBancosOdoo(),
        getIntegraciones(),
        getAnaliticas(),
        getOdooHorarioList(),
        getAllPeriodos(),
        getRegistroPatronalList(),
      ]);

      if (resPuestos?.ok) setPuestos(resPuestos.payload || []);
      if (resSupervisores?.ok) {
        const raw = resSupervisores.payload || [];
        supervisoresRawRef.current = raw;
        const options = raw
          .filter((item) => item.odoo_id || item.id)
          .map((item) => ({
            value: item.odoo_id || item.id,
            text: item.nombre || item.empleado_one2many_name || `Supervisor ${item.id}`,
          }));
        setSupervisores(options);
      }
      if (resDepartamentos?.ok) setDepartamentos(resDepartamentos.payload || []);
      if (resAreas?.ok) setAreasTrabajo(resAreas.payload || []);
      if (resBancos?.ok) setBancos(resBancos.payload || []);
      if (resIntegraciones?.ok) setIntegraciones(resIntegraciones.payload || []);
      if (resAnaliticas?.ok) setAnaliticas(resAnaliticas.payload || []);
      if (resHorarios?.ok) setHorarios(resHorarios.payload || []);
   if (resPeriodos?.ok) setTipoPeriodo(resPeriodos.payload || []);
   if (resRegistro?.ok) setRegistroPatronalList(resRegistro.payload || []);
    } catch (error) {
      console.error('Error cargando catálogos:', error);
    }
  };

  const getTipoContratoLabel = (contractTypeId) => {
    const normalizedContractTypeId = contractTypeId !== null && contractTypeId !== undefined
      ? Number(contractTypeId)
      : null;
    const match = (tiposContrato || []).find((item) => Number(item.value ?? item.id) === normalizedContractTypeId);
    if (!match) return contractTypeId || 'N/A';
    return match.displayTitle || match.text || match.nombre || contractTypeId || 'N/A';
  };

  const getHorarioLabel = (horarioId) => {
    if (empleado?.resource_calendar_name) {
      return empleado.resource_calendar_name;
    }
    const match = (horarios || []).find((item) => String(item.id ?? item.value) === String(horarioId));
    if (!match) return horarioId || 'N/A';
    return match.descripcion || match.text || match.name || horarioId || 'N/A';
  };

  const getDepartamentoLabel = (departmentId) => {
    const normalizedId = departmentId !== null && departmentId !== undefined ? Number(departmentId) : null;
    const match = (departamentos || []).find((item) => Number(item.value ?? item.id) === normalizedId);
    if (!match) return departmentId || 'N/A';
    return match.text || match.name || match.complete_name || departmentId || 'N/A';
  };

  useEffect(() => {
    if (!empleado) {
      return;
    }

    setSalaryForm({
      nomina_daily_salary: Number(empleado.nomina_daily_salary || 0),
      nomina_monthly_salary: Number(empleado.nomina_monthly_salary || 0),
      nomina_variable_amount: Number(empleado.nomina_variable_amount || 0),
      nomina_fixed_amount: Number(empleado.nomina_fixed_amount || 0),
      comentario: '',
      fecha_aplicacion: dayjs(),
    });
    setSalaryPreview(null);
    setSalaryPreviewError(null);
  }, [empleado]);

  useEffect(() => {
    if (!open || !empleado || selectedAction !== 'update_salary') {
      return;
    }

    const timeoutId = setTimeout(() => {
      loadSalaryPreview();
    }, 800);

    return () => clearTimeout(timeoutId);
  }, [
    open,
    empleado,
    selectedAction,
    salaryForm.nomina_daily_salary,
    salaryForm.nomina_monthly_salary,
    salaryForm.nomina_variable_amount,
    salaryForm.nomina_fixed_amount,
    salaryForm.fecha_aplicacion,
  ]);

  useEffect(() => {
    if (!open || selectedAction !== 'deactivate') {
      return;
    }
    loadMotivosBaja();
    if (deactivateForm.nomina_last_period_type) {
      loadPeriodoDetalles(deactivateForm.nomina_last_period_type);
    }
  }, [open, selectedAction]);

  // Resuelve el objeto supervisor para el organigrama.
  // 1) supervisor_id (módulo de Supervisores) -> registro de supervisores -> empleado vinculado
  // 2) fallback: odoo_parent_id -> empleado
  const resolverSupervisor = async (supervisorRegistroId, parentId, allEmpleados) => {
    if (supervisorRegistroId) {
      let registros = supervisoresRawRef.current || [];
      let registro = registros.find((item) => Number(item.id) === supervisorRegistroId);

      if (!registro) {
        const resCatalogo = await getSupervisores();
        if (resCatalogo?.ok) {
          registros = resCatalogo.payload || [];
          supervisoresRawRef.current = registros;
          registro = registros.find((item) => Number(item.id) === supervisorRegistroId);
        }
      }

      if (registro) {
        const empleadoSupervisorId = Number(registro.empleado_id_one2many);
        if (empleadoSupervisorId) {
          const empleadoSupervisor = allEmpleados.find(
            (item) => Number(item.id) === empleadoSupervisorId
          );
          if (empleadoSupervisor) return empleadoSupervisor;

          const resEmpleado = await getEmpleadoById(empleadoSupervisorId);
          if (resEmpleado?.ok) return resEmpleado.payload;
        }

        // El registro de supervisores no tiene empleado vinculado
        return {
          id: registro.id,
          name: registro.nombre || registro.empleado_one2many_name || `Supervisor ${registro.id}`,
          job_title: null,
        };
      }
    }

    if (parentId) {
      const parentEmpleado = allEmpleados.find(
        (item) => Number(item.id) === parentId || Number(item.odoo_id) === parentId
      );
      if (parentEmpleado) return parentEmpleado;

      const supervisorResponse = await getEmpleadoById(parentId);
      return supervisorResponse?.ok ? supervisorResponse.payload : null;
    }

    return null;
  };

  const loadEmpleadoData = async () => {
    try {
      const response = await getEmpleadoById(id);
      if (response.ok) {
        const empleadoPayload = response.payload;
        setEmpleado(empleadoPayload);

        const responseAll = await getAllEmpleados();
        if (responseAll?.ok) {
          const allEmpleados = responseAll.payload || [];
          const empleadoId = Number(empleadoPayload.id);
          const parentId = Number(empleadoPayload.odoo_parent_id);
          const supervisorRegistroId = Number(empleadoPayload.supervisor_id);

          // Subordinados: empleados asignados al registro de supervisores que
          // representa a este empleado. Fallback: odoo_parent_id.
          const registroPropio = (supervisoresRawRef.current || []).find(
            (registro) => Number(registro.empleado_id_one2many) === empleadoId
          );
          let reports = registroPropio
            ? allEmpleados.filter(
                (item) => Number(item.supervisor_id) === Number(registroPropio.id)
              )
            : [];
          if (!reports.length) {
            reports = allEmpleados.filter(
              (item) => Number(item.odoo_parent_id) === empleadoId
            );
          }
          setDirectReports(reports);

          setSupervisor(
            await resolverSupervisor(supervisorRegistroId, parentId, allEmpleados)
          );
        }
      }
    } catch (e) {
      message.error('Error al cargar los datos del empleado');
    }
  };

  const loadDocumentos = async () => {
    if (!id) return;
    setLoadingDocs(true);
    try {
      const response = await getDocumentosByEmpleado(id);
      if (response?.ok) {
        setDocumentos(response.payload || []);
      } else {
        setDocumentos([]);
      }
    } catch (error) {
      setDocumentos([]);
    } finally {
      setLoadingDocs(false);
    }
  };

  const normalizeFotoSrc = (foto) => {
    if (!foto) return null;
    if (foto.startsWith('data:')) return foto;
    return `data:image/png;base64,${foto}`;
  };

  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const beforeFotoUpload = async (file) => {
    if (!file.type.startsWith('image/')) {
      message.error('El archivo debe ser una imagen válida');
      return Upload.LIST_IGNORE;
    }

    setFotoUploading(true);
    try {
      const fotoBase64 = await fileToBase64(file);
      const response = await actualizarFotoEmpleado(id, fotoBase64);
      if (response?.ok) {
        message.success('Foto actualizada correctamente');
        await loadEmpleadoData();
      } else {
        message.error('No se pudo actualizar la foto');
      }
    } catch (e) {
      message.error('Error al subir la foto');
    } finally {
      setFotoUploading(false);
    }
    return false;
  };

  const loadKardexData = async () => {
    setLoadingKardex(true);
    try {
      const response = await getByIdEmpleado(id);
      setKardex(response?.ok ? (response.payload ?? []) : []);
    } catch (e) {
      setKardex([]);
      message.error('Error al cargar el kardex');
    } finally {
      setLoadingKardex(false);
    }
  };

  const onClose = () => {
    finish(false);
    setEmpleado(null);
    setKardex([]);
    setSupervisor(null);
    setDirectReports([]);
    setActiveTab('info');
    setSelectedAction(null);
    setSalaryPreview(null);
    setSalaryPreviewError(null);
    setMotivosBaja([]);
    setSelectedMotivoBaja(null);
    setDeactivateForm(getDefaultDeactivateForm());
    setRehireForm(getDefaultRehireForm());
  };

  const handleOptionsClick = ({ key }) => {
    if (key === 'update_salary') {
      setSelectedAction('update_salary');
      setActiveTab('actions');
      return;
    }

    if (key === 'edit') {
      setSelectedAction('edit');
      setActiveTab('actions');
      setEditForm(getDefaultEditForm(empleado));
      return;
    }

    if (key === 'change_password') {
      setSelectedAction('change_password');
      setActiveTab('actions');
      return;
    }

    if (key === 'deactivate') {
      setSelectedAction('deactivate');
      setActiveTab('actions');
      setDeactivateForm(getDefaultDeactivateForm(empleado));
      return;
    }

    if (key === 'rehire') {
      setSelectedAction('rehire');
      setActiveTab('actions');
      setRehireForm(getDefaultRehireForm(empleado));
    }
  };

  const loadMotivosBaja = async () => {
    setLoadingMotivosBaja(true);
    try {
      const response = await getMotivosBajaList();
      if (response?.ok) {
        setMotivosBaja(response.payload || []);
      } else {
        setMotivosBaja([]);
        notifyApiErrorOnce(response, 'No se pudo cargar el catálogo de motivos de baja.');
      }
    } catch (error) {
      setMotivosBaja([]);
      message.error('No se pudo cargar el catálogo de motivos de baja.');
    } finally {
      setLoadingMotivosBaja(false);
    }
  };

  const loadPeriodoDetalles = async (periodoId) => {
    if (!periodoId) {
      setPeriodoDetalles([]);
      return;
    }

    setLoadingPeriodoDetalles(true);
    try {
      const response = await getDetallesPeriodo(periodoId);
      setPeriodoDetalles(response?.ok ? (response.payload || []) : []);
    } catch (error) {
      setPeriodoDetalles([]);
    } finally {
      setLoadingPeriodoDetalles(false);
    }
  };

  const handleTipoPeriodoBajaChange = (value) => {
    setDeactivateForm((current) => ({
      ...current,
      nomina_last_period_type: value ?? null,
      nomina_last_period: null,
    }));
    loadPeriodoDetalles(value);
  };

  const handleLastPeriodBajaChange = (value) => {
    if (!value) {
      setDeactivateForm((current) => ({ ...current, nomina_last_period: null }));
      return;
    }

    const [anio, numPeriodo] = String(value).split('-');
    setDeactivateForm((current) => ({
      ...current,
      nomina_last_period: numPeriodo ?? null,
      nomina_last_year: anio ? Number(anio) : current.nomina_last_year,
    }));
  };

  const handleApplyDeactivate = async () => {
    if (!empleado) {
      return;
    }

    if (!selectedMotivoBaja) {
      message.warning('Selecciona un motivo de baja antes de continuar.');
      return;
    }

    if (!deactivateForm.nomina_leaving_date || !deactivateForm.nomina_contract_end_date) {
      message.warning('Captura la fecha de salida y la fecha de finalización del contrato antes de continuar.');
      return;
    }

    if (!deactivateForm.nomina_last_period_type || !deactivateForm.nomina_last_year || !deactivateForm.nomina_last_period) {
      message.warning('Selecciona el último tipo de período, año y período antes de continuar.');
      return;
    }

    const motivoSeleccionado = motivosBaja.find((item) => String(item.value) === String(selectedMotivoBaja));
    const motivoDescripcion = motivoSeleccionado?.text || '';

    if (!motivoDescripcion) {
      message.warning('No se encontró la descripción del motivo seleccionado.');
      return;
    }

    setLoadingApplyBaja(true);
    try {
      const payload = {
        nomina_leaving_date: deactivateForm.nomina_leaving_date.format('YYYY-MM-DD'),
        nomina_contract_end_date: deactivateForm.nomina_contract_end_date.format('YYYY-MM-DD'),
        nomina_last_year: deactivateForm.nomina_last_year ?? null,
        nomina_last_period: deactivateForm.nomina_last_period ?? null,
        nomina_last_period_type: deactivateForm.nomina_last_period_type ?? null,
        motivo: motivoDescripcion,
        nomina_can_reenter: deactivateForm.nomina_can_reenter ?? false,
        nomina_leaving_comment: deactivateForm.nomina_leaving_comment ?? null,
      };

      const response = await darBajaEmpleado(id, payload);
      if (!response?.ok) {
        notifyApiErrorOnce(response, 'No se pudo dar de baja al empleado.');
        return;
      }

      message.success('Baja registrada correctamente.');
      const isVisibleInCurrentFilter =
        employeesViewFilter === 'inactive'
          ? Boolean(deactivateForm.nomina_can_reenter)
          : false;

      if (!isVisibleInCurrentFilter) {
        finish(true, false);
        return;
      }

      await loadEmpleadoData();
      await loadKardexData();
    } catch (error) {
      message.error('No se pudo dar de baja al empleado.');
    } finally {
      setLoadingApplyBaja(false);
    }
  };

  const handleApplyRehire = async () => {
    if (!rehireForm.nomina_contract_type_id || !rehireForm.nomina_contract_start_date) {
      message.warning('Selecciona tipo de contrato y fecha de inicio para recontratar.');
      return;
    }

    if (!rehireForm.job_id || !rehireForm.department_id || !rehireForm.periodo_id || !rehireForm.nomina_workarea_id || !rehireForm.nomina_integration_id) {
      message.warning('Puesto, departamento, tipo de período, área e integración son requeridos para reingreso.');
      return;
    }

    setLoadingApplyRehire(true);
    try {
      const payload = {
        nomina_contract_type_id: Number(rehireForm.nomina_contract_type_id),
        nomina_contract_start_date: rehireForm.nomina_contract_start_date.format('YYYY-MM-DD'),
        nomina_contract_end_date: rehireForm.nomina_contract_end_date
          ? rehireForm.nomina_contract_end_date.format('YYYY-MM-DD')
          : null,
        nomina_integration_id: Number(rehireForm.nomina_integration_id),
        nomina_daily_salary: Number(rehireForm.nomina_daily_salary || 0),
        nomina_monthly_salary: Number(rehireForm.nomina_monthly_salary || 0),
        nomina_variable_amount: Number(rehireForm.nomina_variable_amount || 0),
        nomina_fixed_amount: Number(rehireForm.nomina_fixed_amount || 0),
        department_id: Number(rehireForm.department_id),
        periodo_id: Number(rehireForm.periodo_id),
        job_id: Number(rehireForm.job_id),
        nomina_workarea_id: Number(rehireForm.nomina_workarea_id),
        comentario: rehireForm.comentario || null,
      };

      const response = await recontratarEmpleado(id, payload);
      if (!response?.ok) {
        notifyApiErrorOnce(response, 'No se pudo recontratar al empleado.');
        return;
      }

      message.success('Empleado recontratado correctamente.');
      await loadEmpleadoData();
      await loadKardexData();
      setSelectedAction(null);
      setRehireForm(getDefaultRehireForm());
    } catch (error) {
      message.error('No se pudo recontratar al empleado.');
    } finally {
      setLoadingApplyRehire(false);
    }
  };

  const handleApplyEdit = async () => {
    // Campos requeridos
    if (!editForm.nomina_name || !editForm.nomina_first_last_name || !editForm.nomina_second_last_name) {
      message.warning('Nombre, apellido paterno y apellido materno son requeridos.');
      return;
    }
    if (!editForm.nomina_rfc || !editForm.nomina_curp || !editForm.nomina_imss_number) {
      message.warning('RFC, CURP y NSS son requeridos.');
      return;
    }
    if (!editForm.nomina_employee_number || !editForm.job_id || !editForm.department_id) {
      message.warning('Número de empleado, puesto y departamento son requeridos.');
      return;
    }
    if (!editForm.nomina_workarea_id || !editForm.nomina_employee_registration_key || !editForm.nomina_zip_code) {
      message.warning('Área, registro patronal y código postal son requeridos.');
      return;
    }
    if (!editForm.banco_id || !editForm.nomina_entry_date || !editForm.nomina_seniority_date) {
      message.warning('Banco, fecha de ingreso y fecha de antigüedad son requeridos.');
      return;
    }
    if (!editForm.nomina_contract_type_id || !editForm.nomina_contract_start_date) {
      message.warning('Tipo de contrato y fecha de inicio del contrato son requeridos.');
      return;
    }
    if (!editForm.nomina_integration_id || !editForm.periodo_id || !editForm.nomina_wage_scheme) {
      message.warning('Integración, tipo de período y régimen salarial son requeridos.');
      return;
    }

    setLoadingApplyEdit(true);
    try {
      const payload = {
        nomina_name: editForm.nomina_name,
        nomina_first_last_name: editForm.nomina_first_last_name,
        nomina_second_last_name: editForm.nomina_second_last_name,
        work_email: editForm.work_email || null,
        work_phone: editForm.work_phone || null,
        private_street: editForm.private_street || null,
        private_street2: editForm.private_street2 || null,
        private_city: editForm.private_city || null,
        job_id: editForm.job_id,
        analitica_id: editForm.analitica_id || null,
        odoo_parent_id: editForm.odoo_parent_id || null,
        resource_calendar_id: editForm.resource_calendar_id || null,
        nomina_rfc: editForm.nomina_rfc,
        nomina_curp: editForm.nomina_curp,
        nomina_imss_number: editForm.nomina_imss_number,
        nomina_employee_number: editForm.nomina_employee_number,
        department_id: editForm.department_id,
        nomina_workarea_id: editForm.nomina_workarea_id,
        nomina_entry_date: editForm.nomina_entry_date ? editForm.nomina_entry_date.format('YYYY-MM-DD') : null,
        nomina_seniority_date: editForm.nomina_seniority_date ? editForm.nomina_seniority_date.format('YYYY-MM-DD') : null,
        nomina_contract_type_id: Number(editForm.nomina_contract_type_id),
        nomina_contract_start_date: editForm.nomina_contract_start_date.format('YYYY-MM-DD'),
        nomina_contract_end_date: editForm.nomina_contract_end_date ? editForm.nomina_contract_end_date.format('YYYY-MM-DD') : null,
        nomina_integration_id: editForm.nomina_integration_id,
        periodo_id: editForm.periodo_id,
        nomina_employee_registration_key: editForm.nomina_employee_registration_key,
        nomina_zip_code: editForm.nomina_zip_code,
        banco_id: editForm.banco_id,
        nomina_wage_scheme: editForm.nomina_wage_scheme,
        nomina_need_timesheets: Boolean(editForm.nomina_need_timesheets),
      };

      const response = await editarEmpleado(id, payload);
      if (!response?.ok) {
        notifyApiErrorOnce(response, 'No se pudo actualizar los datos del empleado.');
        return;
      }

      message.success('Datos del empleado actualizados correctamente.');
      await loadEmpleadoData();
      await loadKardexData();
      setSelectedAction(null);
    } catch (error) {
      message.error('No se pudo actualizar los datos del empleado.');
    } finally {
      setLoadingApplyEdit(false);
    }
  };

  const getApiErrorMessage = (response, fallback = 'No se pudo procesar la solicitud.') => {
    if (!response) {
      return fallback;
    }

    if (typeof response?.message === 'string') {
      return response.message;
    }

    if (Array.isArray(response?.errors) && response.errors.length > 0) {
      const firstError = response.errors[0];
      if (typeof firstError === 'string') {
        return firstError;
      }
      if (firstError?.msg) {
        return firstError.msg;
      }
      if (firstError?.message) {
        return firstError.message;
      }
    }

    return fallback;
  };

  const notifyApiErrorOnce = (response, fallback = 'No se pudo procesar la solicitud.') => {
    // Tools.js ya muestra message.error cuando ok=false y existen errores.
    const alreadyNotified = Array.isArray(response?.errors) && response.errors.some((err) => {
      if (typeof err === 'string') return Boolean(err);
      return Boolean(err?.msg || err?.message);
    });

    if (!alreadyNotified) {
      message.error(getApiErrorMessage(response, fallback));
    }
  };

  const roundToTwo = (value) => {
    const parsed = Number(value || 0);
    if (Number.isNaN(parsed)) {
      return 0;
    }
    return Number(parsed.toFixed(2));
  };

  const handleSalaryFieldChange = (field, rawValue) => {
    const value = roundToTwo(rawValue);

    setSalaryPreviewError(null);
    setSalaryForm((current) => {
      if (field === 'nomina_daily_salary') {
        return {
          ...current,
          nomina_daily_salary: value,
          nomina_monthly_salary: roundToTwo(value * 30),
        };
      }

      if (field === 'nomina_monthly_salary') {
        return {
          ...current,
          nomina_monthly_salary: value,
          nomina_daily_salary: roundToTwo(value / 30),
        };
      }

      return {
        ...current,
        [field]: value,
      };
    });
  };

  const loadSalaryPreview = async () => {
    if (!empleado) {
      return;
    }

    setLoadingSalaryPreview(true);
    try {
      const payload = {
        fecha_actual: (salaryForm.fecha_aplicacion || dayjs()).format('YYYY-MM-DD'),
        nomina_daily_salary: Number(salaryForm.nomina_daily_salary || 0),
        nomina_monthly_salary: Number(salaryForm.nomina_monthly_salary || 0),
        nomina_variable_amount: Number(salaryForm.nomina_variable_amount || 0),
        nomina_fixed_amount: Number(salaryForm.nomina_fixed_amount || 0),
      };

      const response = await previewActualizacionSalarialEmpleado(id, payload);
      console.log(response);
      if (response?.ok) {
        setSalaryPreview(response.payload);
        setSalaryPreviewError(null);
      } else {
        setSalaryPreview(null);
        setSalaryPreviewError(getApiErrorMessage(response, 'No se pudo previsualizar el salario.'));
      }
    } catch (error) {
      setSalaryPreview(null);
      setSalaryPreviewError('No se pudo previsualizar el salario.');
    } finally {
      setLoadingSalaryPreview(false);
    }
  };

  const handleApplySalaryUpdate = async () => {
    if (!empleado) {
      return;
    }

    setLoadingApplySalary(true);
    try {
      const payload = {
        fecha_actual: (salaryForm.fecha_aplicacion || dayjs()).format('YYYY-MM-DD'),
        nomina_daily_salary: Number(salaryForm.nomina_daily_salary || 0),
        nomina_monthly_salary: Number(salaryForm.nomina_monthly_salary || 0),
        nomina_variable_amount: Number(salaryForm.nomina_variable_amount || 0),
        nomina_fixed_amount: Number(salaryForm.nomina_fixed_amount || 0),
        comentario: salaryForm.comentario || null,
      };

      const response = await aplicarActualizacionSalarialEmpleado(id, payload);
      if (!response?.ok) {
        notifyApiErrorOnce(response, 'No se pudo aplicar la actualización salarial.');
        return;
      }

      message.success('Actualización salarial aplicada correctamente.');
      await loadEmpleadoData();
      await loadKardexData();
      setActiveTab('actions');
      setSelectedAction('update_salary');
    } catch (error) {
      message.error('No se pudo aplicar la actualización salarial.');
    } finally {
      setLoadingApplySalary(false);
    }
  };

  const formatCurrency = (value) => {
    const parsed = Number(value);
    if (Number.isNaN(parsed)) {
      return '0.00';
    }
    return parsed.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  const currencyFormatter = (value, info) => {
    if (info?.userTyping) {
      return info.input;
    }
    if (value === undefined || value === null || value === '') return '';
    const num = Number(value);
    if (Number.isNaN(num)) return '';
    return `$ ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 6 })}`;
  };

  const currencyParser = (value) => {
    if (!value) return 0;
    const cleaned = value.replace(/\$\s?/g, '').replace(/,/g, '');
    const num = parseFloat(cleaned);
    return Number.isNaN(num) ? 0 : num;
  };

  const getContractStatus = () => {
    if (!empleado) return { status: 'unknown', color: 'default', label: 'Sin datos' };
    
    if (!empleado.nomina_contract_start_date) {
      return { status: 'unknown', color: 'default', label: 'Sin fecha de contrato' };
    }

    const startDate = dayjs(empleado.nomina_contract_start_date);
    const endDate = dayjs(empleado.nomina_contract_end_date);
    const today = dayjs();
    const isActive = today.isAfter(startDate) && (!empleado.nomina_contract_end_date || today.isBefore(endDate.add(1, 'day')));

    return {
      status: isActive ? 'active' : 'inactive',
      color: isActive ? 'green' : 'red',
      label: isActive ? 'Contrato Activo' : 'Contrato Inactivo'
    };
  };

  const contractStatus = getContractStatus();
  const salaryPreviewDetail = salaryPreview?.detalle || {};

  const kardexColumns = [
    {
      title: 'Fecha',
      dataIndex: 'fecha',
      key: 'fecha',
      render: (date) => dayjs(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Movimiento',
      dataIndex: 'movimiento',
      key: 'movimiento',
    },
    {
      title: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
    },
    {
      title: 'Comentarios',
      dataIndex: 'comentarios',
      key: 'comentarios',
    },
  ];

  const renderGeneralInfo = () => {
    if (!empleado) return <Empty />;

    return (
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card title="Información General" className="info-card">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Nombre:</span>
                  <span className="info-value">{empleado.nomina_name}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Apellido Paterno:</span>
                  <span className="info-value">{empleado.nomina_first_last_name || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Apellido Materno:</span>
                  <span className="info-value">{empleado.nomina_second_last_name || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">RFC:</span>
                  <span className="info-value">{empleado.nomina_rfc}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">CURP:</span>
                  <span className="info-value">{empleado.nomina_curp}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">NSS:</span>
                  <span className="info-value">{empleado.nomina_imss_number}</span>
                </div>
              </Col>
                            <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Número de Empleado:</span>
                  <span className="info-value">{empleado.nomina_employee_number}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Departamento:</span>
                  <span className="info-value">{getDepartamentoLabel(empleado.department_id)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Clave Corta:</span>
                  <span className="info-value">{empleado.short_code || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Tipo de Contrato:</span>
                  <span className="info-value">{getTipoContratoLabel(empleado.nomina_contract_type_id)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Horario de Trabajo:</span>
                  <span className="info-value">{getHorarioLabel(empleado.resource_calendar_id)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Checa tarjeta:</span>
                  <span className="info-value">{empleado.nomina_need_timesheets ? 'Sí' : 'No'}</span>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Dirección Particular" className="info-card">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Calle:</span>
                  <span className="info-value">{empleado.private_street || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Colonia:</span>
                  <span className="info-value">{empleado.private_street2 || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Ciudad:</span>
                  <span className="info-value">{empleado.private_city || 'N/A'}</span>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Información de Nómina" className="info-card">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Salario Diario:</span>
                  <span className="info-value">${formatCurrency(empleado.nomina_daily_salary)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Salario Mensual:</span>
                  <span className="info-value">${formatCurrency(empleado.nomina_monthly_salary)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Monto Fijo:</span>
                  <span className="info-value">${formatCurrency(empleado.nomina_fixed_amount)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Monto Variable:</span>
                  <span className="info-value">${formatCurrency(empleado.nomina_variable_amount)}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Fecha Ingreso:</span>
                  <span className="info-value">
                    {empleado.nomina_entry_date ? dayjs(empleado.nomina_entry_date).format('DD/MM/YYYY') : 'N/A'}
                  </span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Fecha Antigüedad:</span>
                  <span className="info-value">
                    {empleado.nomina_seniority_date ? dayjs(empleado.nomina_seniority_date).format('DD/MM/YYYY') : 'N/A'}
                  </span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Factor de Integración:</span>
                  <span className="info-value">{empleado.nomina_integration_factor || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div className="info-item">
                  <span className="info-label">Salario Integrado:</span>
                  <span className="info-value">${formatCurrency(empleado.nomina_integrated_salary)}</span>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Información de Contacto" className="info-card">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={12}>
                <div className="info-item">
                  <span className="info-label">Correo de Trabajo:</span>
                  <span className="info-value">{empleado.work_email || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={12}>
                <div className="info-item">
                  <span className="info-label">Teléfono de Trabajo:</span>
                  <span className="info-value">{empleado.work_phone || 'N/A'}</span>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={24}>
          <Card title="Datos SAT" className="info-card">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Registro Patronal:</span>
                  <span className="info-value">{empleado.nomina_employer_registration_key || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Código Postal:</span>
                  <span className="info-value">{empleado.nomina_zip_code || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Banco de Depósito:</span>
                  <span className="info-value">{empleado.banco_name || empleado.banco_id || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Régimen Salarial:</span>
                  <span className="info-value">{regimenesSalariales.find((item) => String(item.value) === String(empleado.nomina_wage_scheme))?.text || empleado.nomina_wage_scheme || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Fecha de Baja:</span>
                  <span className="info-value">
                    {empleado.nomina_leaving_date ? dayjs(empleado.nomina_leaving_date).format('DD/MM/YYYY') : 'N/A'}
                  </span>
                </div>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <div className="info-item">
                  <span className="info-label">Reingreso:</span>
                  <span className="info-value">{empleado.nomina_can_reenter != null ? (empleado.nomina_can_reenter ? 'Sí' : 'No') : 'N/A'}</span>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  };

  const renderOrganigramTab = () => {
    if (!empleado) return <Empty />;

    return (
      <Card style={{ marginBottom: 16 }}>
        <div style={{ padding: '20px', backgroundColor: '#fafafa', borderRadius: '4px' }}>
          <div style={{ marginBottom: 16, fontWeight: 'bold', fontSize: '14px' }}>
            <TeamOutlined /> Organigrama del Empleado
          </div>

          {supervisor ? (
            <div style={{ marginBottom: 16, padding: '12px', backgroundColor: '#fff', borderRadius: '4px', borderLeft: '4px solid #1890ff' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Supervisor Directo</div>
              <div>{supervisor.name}</div>
              <div style={{ fontSize: '12px', color: '#999', marginTop: '4px' }}>{supervisor.job_title || 'Sin puesto'}</div>
            </div>
          ) : (
            <Result status="info" title="Sin supervisor" subTitle="Este empleado no tiene supervisor asignado." />
          )}

          <div style={{ padding: '12px', backgroundColor: '#e6f7ff', borderRadius: '4px', borderLeft: '4px solid #1890ff', marginBottom: 16 }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Empleado</div>
            <div>{empleado.name}</div>
            <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>{empleado.job_title || 'Sin puesto'}</div>
          </div>

          {directReports.length > 0 ? (
            <div style={{ padding: '12px', backgroundColor: '#f6ffed', borderRadius: '4px', borderLeft: '4px solid #52c41a' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Subordinados ({directReports.length})</div>
              {directReports.map((report) => (
                <div key={report.id} style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #d9d9d9' }}>
                  <div>{report.name}</div>
                  <div style={{ fontSize: '12px', color: '#999' }}>{report.job_title || 'Sin puesto'}</div>
                </div>
              ))}
            </div>
          ) : (
            <Result status="info" title="Sin subordinados" subTitle="Este empleado no tiene subordinados asignados." />
          )}
        </div>
      </Card>
    );
  };

  const renderContractStatus = () => {
    if (!empleado) return <Empty />;

    return (
      <Card style={{ marginBottom: 16 }}>
        <Row gutter={16} align="middle">
          <Col xs={24} sm={12} md={12}>
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ marginBottom: '16px' }}>
                {contractStatus.color === 'green' ? (
                  <CheckCircleOutlined style={{ fontSize: '48px', color: '#52c41a' }} />
                ) : (
                  <CloseCircleOutlined style={{ fontSize: '48px', color: '#f5222d' }} />
                )}
              </div>
              <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>
                {contractStatus.label}
              </div>
              <Tag color={contractStatus.color === 'green' ? 'green' : 'red'}>
                {contractStatus.label}
              </Tag>
            </div>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <div style={{ padding: '20px' }}>
              <div className="info-item" style={{ marginBottom: '16px' }}>
                <span className="info-label">Fecha de Inicio:</span>
                <span className="info-value">
                  {empleado.nomina_contract_start_date ? dayjs(empleado.nomina_contract_start_date).format('DD/MM/YYYY') : 'N/A'}
                </span>
              </div>
              <div className="info-item" style={{ marginBottom: '16px' }}>
                <span className="info-label">Tipo de Contrato:</span>
                <span className="info-value">
                  {getTipoContratoLabel(empleado.nomina_contract_type_id)}
                </span>
              </div>
              {empleado.nomina_contract_end_date && (
                <div className="info-item">
                  <span className="info-label">Fecha de Término:</span>
                  <span className="info-value">
                    {dayjs(empleado.nomina_contract_end_date).format('DD/MM/YYYY')}
                  </span>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  const renderKardexTab = () => {
    return (
      <Spin spinning={loadingKardex}>
        {kardex.length === 0 ? (
          <Empty description="No hay movimientos registrados" />
        ) : (
          <Table dataSource={kardex} columns={kardexColumns} rowKey="id" pagination={{ pageSize: 10 }} />
        )}
      </Spin>
    );
  };

  const renderActionsTab = () => {
    if (!selectedAction) {
      return <Empty description="Selecciona una acción desde el menú Acciones." />;
    }

    if (selectedAction === 'change_password') {
      return (
        <ChangePassword id={empleado.id} inline finish={(refresh) => {
          setSelectedAction(null);
          if (refresh) {
            loadEmpleadoData();
            loadKardexData();
          }
        }} />
      );
    }

    if (selectedAction === 'deactivate') {
      return (
        <Card title="Dar de baja">
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <div className="info-item">
              <span className="info-label">Fecha de baja</span>
              <DatePicker
                style={{ width: '100%' }}
                value={deactivateForm.nomina_leaving_date}
                onChange={(value) => setDeactivateForm((current) => ({ ...current, nomina_leaving_date: value }))}
                format="DD/MM/YYYY"
                placeholder="Selecciona fecha de baja"
              />
            </div>

            <div className="info-item">
              <span className="info-label">Fecha de finalización del contrato</span>
              <DatePicker
                style={{ width: '100%' }}
                value={deactivateForm.nomina_contract_end_date}
                onChange={(value) => setDeactivateForm((current) => ({ ...current, nomina_contract_end_date: value }))}
                format="DD/MM/YYYY"
                placeholder="Selecciona fecha de finalización del contrato"
              />
            </div>

            <div className="info-item">
              <span className="info-label">Motivo de baja</span>
              <Select
                showSearch
                allowClear
                placeholder="Selecciona un motivo"
                style={{ width: '100%' }}
                loading={loadingMotivosBaja}
                value={selectedMotivoBaja}
                onChange={setSelectedMotivoBaja}
                options={motivosBaja.map((item) => ({ value: item.value, label: item.text }))}
                optionFilterProp="label"
              />
            </div>

            <div className="info-item">
              <Checkbox
                checked={Boolean(deactivateForm.nomina_can_reenter)}
                onChange={(event) => setDeactivateForm((current) => ({ ...current, nomina_can_reenter: event.target.checked }))}
              >
                Apto para reingreso
              </Checkbox>
            </div>

            <div className="info-item">
              <span className="info-label">Último tipo de período</span>
              <Select
                showSearch
                allowClear
                placeholder="Selecciona un tipo de período"
                style={{ width: '100%' }}
                value={deactivateForm.nomina_last_period_type || undefined}
                onChange={handleTipoPeriodoBajaChange}
                options={tipoPeriodo.map((item) => ({ value: String(item.value), label: item.text }))}
                optionFilterProp="label"
              />
            </div>

            <div className="info-item">
              <span className="info-label">Último período</span>
              <Select
                showSearch
                allowClear
                placeholder={
                  deactivateForm.nomina_last_period_type
                    ? 'Selecciona un período'
                    : 'Selecciona primero un tipo de período'
                }
                style={{ width: '100%' }}
                loading={loadingPeriodoDetalles}
                disabled={!deactivateForm.nomina_last_period_type}
                value={
                  deactivateForm.nomina_last_period
                    ? `${deactivateForm.nomina_last_year || ''}-${deactivateForm.nomina_last_period}`
                    : undefined
                }
                onChange={handleLastPeriodBajaChange}
                options={periodoDetalles.map((item) => ({
                  value: `${item.anio}-${String(item.num_periodo)}`,
                  label: `${item.anio} - ${item.descripcion || `P${item.num_periodo}`}`,
                }))}
                optionFilterProp="label"
              />
            </div>

            <div className="info-item">
              <span className="info-label">Último año</span>
              <InputNumber
                style={{ width: '100%' }}
                min={2000}
                max={9999}
                value={deactivateForm.nomina_last_year}
                onChange={(value) => setDeactivateForm((current) => ({ ...current, nomina_last_year: value }))}
              />
            </div>

            <div className="info-item">
              <span className="info-label">Comentarios de baja</span>
              <Input.TextArea
                placeholder="Escribe aquí comentarios adicionales sobre la baja"
                value={deactivateForm.nomina_leaving_comment || ''}
                onChange={(e) => setDeactivateForm((current) => ({ ...current, nomina_leaving_comment: e.target.value }))}
                rows={3}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="primary"
                danger
                onClick={handleApplyDeactivate}
                loading={loadingApplyBaja}
                disabled={
                  !selectedMotivoBaja
                  || !deactivateForm.nomina_leaving_date
                  || !deactivateForm.nomina_contract_end_date
                  || !deactivateForm.nomina_last_period_type
                  || !deactivateForm.nomina_last_year
                  || !deactivateForm.nomina_last_period
                }
              >
                Confirmar baja
              </Button>
            </div>
          </Space>
        </Card>
      );
    }

    if (selectedAction === 'rehire') {
      return (
        <Card title="Reingresar empleado">
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <div className="info-item">
              <span className="info-label">Tipo de contrato</span>
              <Select
                allowClear
                placeholder="Selecciona tipo de contrato"
                style={{ width: '100%' }}
                value={rehireForm.nomina_contract_type_id}
                onChange={(value) => setRehireForm((current) => ({ ...current, nomina_contract_type_id: value }))}
                options={tiposContrato.map((item) => ({
                  value: item.value ?? item.id,
                  label: item.displayTitle || item.text || item.nombre,
                }))}
              />
            </div>

            <div className="info-item">
              <span className="info-label">Fecha inicio contrato</span>
              <DatePicker
                style={{ width: '100%' }}
                value={rehireForm.nomina_contract_start_date}
                onChange={(value) => setRehireForm((current) => ({ ...current, nomina_contract_start_date: value }))}
                format="DD/MM/YYYY"
                placeholder="Selecciona fecha de inicio"
              />
            </div>

            <div className="info-item">
              <span className="info-label">Fecha fin contrato (opcional)</span>
              <DatePicker
                style={{ width: '100%' }}
                value={rehireForm.nomina_contract_end_date}
                onChange={(value) => setRehireForm((current) => ({ ...current, nomina_contract_end_date: value }))}
                format="DD/MM/YYYY"
                placeholder="Selecciona fecha de fin"
              />
            </div>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <div className="info-item">
                  <span className="info-label">Puesto</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un puesto"
                    value={rehireForm.job_id}
                    onChange={(value) => setRehireForm((current) => ({ ...current, job_id: value }))}
                    options={puestos.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="info-item">
                  <span className="info-label">Departamento</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un departamento"
                    value={rehireForm.department_id}
                    onChange={(value) => setRehireForm((current) => ({ ...current, department_id: value }))}
                    options={departamentos.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} md={12}>
                <div className="info-item">
                  <span className="info-label">Tipo de período</span>
                  <Select
                    allowClear
                    placeholder="Selecciona tipo de período"
                    value={rehireForm.periodo_id}
                    onChange={(value) => setRehireForm((current) => ({ ...current, periodo_id: value }))}
                    options={tipoPeriodo.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="info-item">
                  <span className="info-label">Área</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un área"
                    value={rehireForm.nomina_workarea_id}
                    onChange={(value) => setRehireForm((current) => ({ ...current, nomina_workarea_id: value }))}
                    options={areasTrabajo.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
            </Row>

            <div className="info-item">
              <span className="info-label">Tabla de integración</span>
              <Select
                allowClear
                placeholder="Selecciona integración"
                style={{ width: '100%' }}
                value={rehireForm.nomina_integration_id}
                onChange={(value) => setRehireForm((current) => ({ ...current, nomina_integration_id: value }))}
                options={integraciones.map((item) => ({ value: item.value, label: item.text }))}
              />
            </div>

            <Row gutter={16}>
              <Col xs={24} md={6}>
                <div className="info-item">
                  <span className="info-label">Salario Diario</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={rehireForm.nomina_daily_salary}
                    onChange={(value) => setRehireForm((current) => {
                      const daily = Number(value || 0);
                      return {
                        ...current,
                        nomina_daily_salary: daily,
                        nomina_monthly_salary: Number((daily * 30).toFixed(2)),
                      };
                    })}
                  />
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="info-item">
                  <span className="info-label">Salario Mensual</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={rehireForm.nomina_monthly_salary}
                    disabled
                  />
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="info-item">
                  <span className="info-label">Monto Variable</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={rehireForm.nomina_variable_amount}
                    onChange={(value) => setRehireForm((current) => ({ ...current, nomina_variable_amount: Number(value || 0) }))}
                  />
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="info-item">
                  <span className="info-label">Monto Fijo</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={rehireForm.nomina_fixed_amount}
                    onChange={(value) => setRehireForm((current) => ({ ...current, nomina_fixed_amount: Number(value || 0) }))}
                  />
                </div>
              </Col>
            </Row>

            <div className="info-item">
              <span className="info-label">Comentario</span>
              <TextArea
                rows={3}
                placeholder="Comentario de reingreso"
                value={rehireForm.comentario}
                onChange={(event) => setRehireForm((current) => ({ ...current, comentario: event.target.value }))}
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type="primary"
                onClick={handleApplyRehire}
                loading={loadingApplyRehire}
                disabled={
                  !rehireForm.nomina_contract_type_id
                  || !rehireForm.nomina_contract_start_date
                  || !rehireForm.job_id
                  || !rehireForm.department_id
                  || !rehireForm.periodo_id
                  || !rehireForm.nomina_workarea_id
                  || !rehireForm.nomina_integration_id
                }
              >
                Confirmar reingreso
              </Button>
            </div>
          </Space>
        </Card>
      );
    }

    if (selectedAction === 'edit') {
      return (
        <Card title="Editar datos del empleado">
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <h4>Información de Contacto</h4>
            <Row gutter={16}>
              <Col md={12} xs={24}>
                <div className="info-item">
                  <span className="info-label">Nombres</span>
                  <Input
                    value={editForm.nomina_name}
                    onChange={(e) => setEditForm({ ...editForm, nomina_name: e.target.value })}
                    placeholder="Nombres"
                  />
                </div>
              </Col>
              <Col md={6} xs={24}>
                <div className="info-item">
                  <span className="info-label">Apellido Paterno</span>
                  <Input
                    value={editForm.nomina_first_last_name}
                    onChange={(e) => setEditForm({ ...editForm, nomina_first_last_name: e.target.value })}
                    placeholder="Apellido Paterno"
                  />
                </div>
              </Col>
              <Col md={6} xs={24}>
                <div className="info-item">
                  <span className="info-label">Apellido Materno</span>
                  <Input
                    value={editForm.nomina_second_last_name}
                    onChange={(e) => setEditForm({ ...editForm, nomina_second_last_name: e.target.value })}
                    placeholder="Apellido Materno"
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={12} xs={24}>
                <div className="info-item">
                  <span className="info-label">Correo de Trabajo</span>
                  <Input
                    type="email"
                    value={editForm.work_email}
                    onChange={(e) => setEditForm({ ...editForm, work_email: e.target.value })}
                    placeholder="Correo"
                  />
                </div>
              </Col>
              <Col md={12} xs={24}>
                <div className="info-item">
                  <span className="info-label">Teléfono de Trabajo</span>
                  <Input
                    value={editForm.work_phone}
                    onChange={(e) => setEditForm({ ...editForm, work_phone: e.target.value })}
                    placeholder="Teléfono"
                  />
                </div>
              </Col>
            </Row>

            <h4>Dirección Particular</h4>
            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Calle</span>
                  <Input
                    value={editForm.private_street}
                    onChange={(e) => setEditForm({ ...editForm, private_street: e.target.value })}
                    placeholder="Calle"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Colonia</span>
                  <Input
                    value={editForm.private_street2}
                    onChange={(e) => setEditForm({ ...editForm, private_street2: e.target.value })}
                    placeholder="Colonia"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Ciudad</span>
                  <Input
                    value={editForm.private_city}
                    onChange={(e) => setEditForm({ ...editForm, private_city: e.target.value })}
                    placeholder="Ciudad"
                  />
                </div>
              </Col>
            </Row>

            <h4>Información Laboral</h4>
            <Row gutter={16}>
              <Col md={12} xs={24}>
                <div className="info-item">
                  <span className="info-label">Puesto</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un puesto"
                    value={editForm.job_id}
                    onChange={(value) => setEditForm({ ...editForm, job_id: value })}
                    options={puestos.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col md={12} xs={24}>
                <div className="info-item">
                  <span className="info-label">Analítica</span>
                  <Select
                    allowClear
                    placeholder="Selecciona una analítica"
                    value={editForm.analitica_id}
                    onChange={(value) => setEditForm({ ...editForm, analitica_id: value })}
                    options={analiticas.map((item) => ({ value: item.id, label: item.name }))}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Supervisor</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un supervisor"
                    value={editForm.odoo_parent_id}
                    onChange={(value) => setEditForm({ ...editForm, odoo_parent_id: value })}
                    options={supervisores}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Horario de Trabajo</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un horario"
                    value={editForm.resource_calendar_id}
                    onChange={(value) => setEditForm({ ...editForm, resource_calendar_id: value })}
                    options={horarios.map((item) => ({ value: item.id, label: item.descripcion }))}
                  />
                </div>
              </Col>
            </Row>

            <h4>Datos de Nómina</h4>
            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">RFC</span>
                  <Input
                    value={editForm.nomina_rfc}
                    onChange={(e) => setEditForm({ ...editForm, nomina_rfc: e.target.value })}
                    placeholder="RFC"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">CURP</span>
                  <Input
                    value={editForm.nomina_curp}
                    onChange={(e) => setEditForm({ ...editForm, nomina_curp: e.target.value })}
                    placeholder="CURP"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">NSS</span>
                  <Input
                    value={editForm.nomina_imss_number}
                    onChange={(e) => setEditForm({ ...editForm, nomina_imss_number: e.target.value })}
                    placeholder="NSS"
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Número de Empleado</span>
                  <Input
                    value={editForm.nomina_employee_number}
                    onChange={(e) => setEditForm({ ...editForm, nomina_employee_number: e.target.value })}
                    placeholder="Número de Empleado"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Departamento</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un departamento"
                    value={editForm.department_id}
                    onChange={(value) => setEditForm({ ...editForm, department_id: value })}
                    options={departamentos.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Área</span>
                  <Select
                    allowClear
                    placeholder="Selecciona un área"
                    value={editForm.nomina_workarea_id}
                    onChange={(value) => setEditForm({ ...editForm, nomina_workarea_id: value })}
                    options={areasTrabajo.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Fecha de Ingreso</span>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={editForm.nomina_entry_date}
                    onChange={(value) => setEditForm({ ...editForm, nomina_entry_date: value })}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Fecha de Antigüedad</span>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={editForm.nomina_seniority_date}
                    onChange={(value) => setEditForm({ ...editForm, nomina_seniority_date: value })}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Tipo de Contrato</span>
                  <Select
                    allowClear
                    placeholder="Selecciona tipo de contrato"
                    value={editForm.nomina_contract_type_id}
                    onChange={(value) => setEditForm({ ...editForm, nomina_contract_type_id: value })}
                    options={tiposContrato.map((item) => ({
                      value: item.value ?? item.id,
                      label: item.displayTitle || item.text || item.nombre,
                    }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Fecha Inicio Contrato</span>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={editForm.nomina_contract_start_date}
                    onChange={(value) => setEditForm({ ...editForm, nomina_contract_start_date: value })}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Fecha Fin Contrato (opcional)</span>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={editForm.nomina_contract_end_date}
                    onChange={(value) => setEditForm({ ...editForm, nomina_contract_end_date: value })}
                    format="DD/MM/YYYY"
                  />
                </div>
              </Col>
            </Row>

            <h4>Datos Salariales</h4>
            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Integración</span>
                  <Select
                    allowClear
                    placeholder="Selecciona integración"
                    value={editForm.nomina_integration_id}
                    onChange={(value) => setEditForm({ ...editForm, nomina_integration_id: value })}
                    options={integraciones.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Tipo de Período</span>
                  <Select
                    allowClear
                    placeholder="Selecciona tipo de período"
                    value={editForm.periodo_id}
                    onChange={(value) => setEditForm({ ...editForm, periodo_id: value })}
                     options={tipoPeriodo.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Régimen Salarial</span>
                  <Select
                    allowClear
                    placeholder="Selecciona régimen"
                    value={editForm.nomina_wage_scheme}
                    onChange={(value) => setEditForm({ ...editForm, nomina_wage_scheme: value })}
                    options={regimenesSalariales.map((item) => ({ value: item.value, label: item.text }))}
                  />
                </div>
              </Col>
            </Row>

            <h4>Datos SAT</h4>
            <Row gutter={16}>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Registro Patronal</span>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Selecciona un registro patronal"
                    value={editForm.nomina_employee_registration_key}
                    onChange={(value) => setEditForm({ ...editForm, nomina_employee_registration_key: value })}
                    options={registroPatronalList.map((item) => ({
                      value: item.clave_patronal || item.value,
                      label: item.displayTitle || item.text || item.clave_patronal || item.value,
                    }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Código Postal</span>
                  <Input
                    value={editForm.nomina_zip_code}
                    onChange={(e) => setEditForm({ ...editForm, nomina_zip_code: e.target.value })}
                    placeholder="Código Postal"
                    maxLength={5}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Banco de Depósito</span>
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Selecciona un banco"
                    value={editForm.banco_id}
                    onChange={(value) => setEditForm({ ...editForm, banco_id: value })}
                    options={bancos.map((item) => ({ value: item.id, label: item.display_name || item.name }))}
                  />
                </div>
              </Col>
              <Col md={8} xs={24}>
                <div className="info-item">
                  <span className="info-label">Checadas</span>
                  <Checkbox
                    checked={Boolean(editForm.nomina_need_timesheets)}
                    onChange={(e) => setEditForm({ ...editForm, nomina_need_timesheets: e.target.checked })}
                  >
                    Checa tarjeta
                  </Checkbox>
                </div>
              </Col>
            </Row>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
              <Button
                type="primary"
                onClick={handleApplyEdit}
                loading={loadingApplyEdit}
              >
                Guardar cambios
              </Button>
            </div>
          </Space>
        </Card>
      );
    }

    return (
      <Spin spinning={loadingSalaryPreview || loadingApplySalary}>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <Card title="Actualizar salario">
            <Row gutter={16}>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Salario Diario</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={salaryForm.nomina_daily_salary}
                    onChange={(value) => handleSalaryFieldChange('nomina_daily_salary', value)}
                    formatter={currencyFormatter}
                    parser={currencyParser}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Salario Mensual</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={salaryForm.nomina_monthly_salary}
                    onChange={(value) => handleSalaryFieldChange('nomina_monthly_salary', value)}
                    formatter={currencyFormatter}
                    parser={currencyParser}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Salario Integrado</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={Number(salaryPreview?.salario_diario_integrado || empleado?.nomina_integrated_salary || 0)}
                    disabled
                    formatter={currencyFormatter}
                    parser={currencyParser}
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Fecha de aplicación</span>
                  <DatePicker
                    style={{ width: '100%' }}
                    value={salaryForm.fecha_aplicacion}
                    onChange={(value) => setSalaryForm((current) => ({ ...current, fecha_aplicacion: value }))}
                    format="DD/MM/YYYY"
                    placeholder="Selecciona fecha de aplicación"
                  />
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col xs={24} md={6}>
                <div className="metric-box">
                  <span className="info-label">Antigüedad</span>
                  <span className="info-value">{salaryPreviewDetail.antiguedad != null ? roundToTwo(salaryPreviewDetail.antiguedad) : 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="metric-box">
                  <span className="info-label">Tabla de Integración</span>
                  <span className="info-value">{salaryPreviewDetail.tabla || 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="metric-box">
                  <span className="info-label">Factor de Integración</span>
                  <span className="info-value">{salaryPreviewDetail.factor_integracion != null ? salaryPreviewDetail.factor_integracion : 'N/A'}</span>
                </div>
              </Col>
              <Col xs={24} md={6}>
                <div className="metric-box">
                  <span className="info-label">UMA</span>
                  <span className="info-value">${salaryPreviewDetail.uma != null ? formatCurrency(salaryPreviewDetail.uma) : '0.00'}</span>
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Monto Variable</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={salaryForm.nomina_variable_amount}
                    onChange={(value) => handleSalaryFieldChange('nomina_variable_amount', value)}
                    formatter={currencyFormatter}
                    parser={currencyParser}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="info-item">
                  <span className="info-label">Monto Fijo</span>
                  <InputNumber
                    min={0}
                    style={{ width: '100%' }}
                    value={salaryForm.nomina_fixed_amount}
                    onChange={(value) => handleSalaryFieldChange('nomina_fixed_amount', value)}
                    formatter={currencyFormatter}
                    parser={currencyParser}
                  />
                </div>
              </Col>
              <Col xs={24} md={8}>
                <div className="metric-box">
                  <span className="info-label">Fijo Topado</span>
                  <span className="info-value">${salaryPreviewDetail.fijo_topado != null ? formatCurrency(salaryPreviewDetail.fijo_topado) : '0.00'}</span>
                </div>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col span={24}>
                <div className="info-item">
                  <span className="info-label">Comentario</span>
                  <TextArea
                    rows={3}
                    value={salaryForm.comentario}
                    onChange={(event) => setSalaryForm((current) => ({ ...current, comentario: event.target.value }))}
                    placeholder="Escribe un comentario para los movimientos generados"
                  />
                </div>
              </Col>
            </Row>

            {salaryPreviewError && (
              <Alert
                type="error"
                showIcon
                message="No se pudo obtener la vista previa"
                description={salaryPreviewError}
                style={{ marginTop: 16 }}
              />
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
              <Button type="primary" onClick={handleApplySalaryUpdate} loading={loadingApplySalary} disabled={Boolean(salaryPreviewError)}>
                Aplicar actualización
              </Button>
            </div>
          </Card>
        </Space>
      </Spin>
    );
  };

  const accionesItems = empleado?.activo
    ? [
        { key: 'edit', label: 'Modificación general' },
        { key: 'update_salary', label: 'Actualizar salario' },
        { key: 'change_password', label: 'Actualizar contraseña' },
        { key: 'deactivate', label: 'Dar de baja' },
      ]
    : [
        { key: 'rehire', label: 'Reingresar' },
      ];

  const handleUploadDocumento = async (info) => {
    const file = info.file;
    const maxSize = 5 * 1024 * 1024;
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

    if (file.size > maxSize) {
      message.error('El archivo excede el tamaño máximo de 5MB');
      return;
    }
    if (!allowedTypes.includes(file.type)) {
      message.error('Tipo de archivo no permitido. Solo se aceptan: PDF, JPG, PNG, DOC, DOCX');
      return;
    }

    setUploadingDoc(true);
    try {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64 = reader.result.split(',')[1];
        const response = await uploadDocumento({
          odoo_empleado_id: id,
          file_base64: base64,
          filename: file.name,
          type: file.name.split('.').pop().toLowerCase(),
          description: '',
        });
        if (response?.ok) {
          message.success('Documento subido correctamente');
          await loadDocumentos();
        } else {
          message.error('Error al subir el documento');
        }
        setUploadingDoc(false);
      };
      reader.onerror = () => {
        message.error('Error al leer el archivo');
        setUploadingDoc(false);
      };
      reader.readAsDataURL(file);
    } catch (e) {
      message.error('Error al subir el documento');
      setUploadingDoc(false);
    }
  };

  const handleDownloadDocumento = async (doc) => {
    try {
      const response = await downloadDocumento(doc.id);
      if (response?.ok && response.payload?.contenido_base64) {
        const byteCharacters = atob(response.payload.contenido_base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const ext = doc.tipo_archivo?.toLowerCase() || 'pdf';
        const mimeTypes = { pdf: 'application/pdf', jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', doc: 'application/msword', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };
        const blob = new Blob([byteArray], { type: mimeTypes[ext] || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = doc.nombre_original;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        message.error('Error al descargar el documento');
      }
    } catch (e) {
      message.error('Error al descargar el documento');
    }
  };

  const handleDeleteDocumento = async (doc) => {
    try {
      const response = await deleteDocumento(doc.id);
      if (response?.ok) {
        message.success('Documento eliminado correctamente');
        await loadDocumentos();
      } else {
        message.error('Error al eliminar el documento');
      }
    } catch (e) {
      message.error('Error al eliminar el documento');
    }
  };

  const documentosColumns = [
    { title: 'Nombre', dataIndex: 'nombre_original', key: 'nombre_original', ellipsis: true },
    { title: 'Tipo', dataIndex: 'tipo_archivo', key: 'tipo_archivo', width: 80, render: (v) => v?.toUpperCase() },
    { title: 'Descripción', dataIndex: 'description', key: 'description', ellipsis: true },
    { title: 'Fecha', dataIndex: 'date_created', key: 'date_created', width: 120, render: (v) => v ? dayjs(v).format('DD/MM/YYYY') : '' },
    {
      title: 'Acciones', key: 'acciones', width: 120,
      render: (_, record) => (
        <Space size="small">
          <Button size="small" icon={<DownloadOutlined />} onClick={() => handleDownloadDocumento(record)} />
          <Button size="small" danger icon={<DeleteOutlined />} onClick={() => handleDeleteDocumento(record)} />
        </Space>
      ),
    },
  ];

  const renderDocumentsTab = () => (
    <Card title="Documentos del empleado">
      <Space direction="vertical" size={16} style={{ width: '100%' }}>
        <Upload.Dragger
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
          showUploadList={false}
          beforeUpload={(file) => {
            handleUploadDocumento({ file });
            return false;
          }}
          disabled={uploadingDoc}
        >
          <p className="ant-upload-drag-icon"><UploadOutlined /></p>
          <p className="ant-upload-text">Haz clic o arrastra un archivo para subirlo</p>
          <p className="ant-upload-hint">Máximo 5MB. Permitidos: PDF, JPG, PNG, DOC, DOCX</p>
        </Upload.Dragger>
        <Table
          columns={documentosColumns}
          dataSource={documentos}
          rowKey="id"
          loading={loadingDocs}
          pagination={{ pageSize: 10 }}
          locale={{ emptyText: <Empty description="No hay documentos registrados" /> }}
        />
      </Space>
    </Card>
  );

  const tabItems = [
    {
      key: 'info',
      label: 'Información General',
      children: renderGeneralInfo(),
    },
    {
      key: 'organigram',
      label: (
        <>
          <TeamOutlined /> Organigrama
        </>
      ),
      children: renderOrganigramTab(),
    },
    {
      key: 'contract',
      label: (
        <>
          <FileTextOutlined /> Contrato
        </>
      ),
      children: renderContractStatus(),
    },
    {
      key: 'movements',
      label: (
        <>
          <FileTextOutlined /> Movimientos
        </>
      ),
      children: renderKardexTab(),
    },
    {
      key: 'documents',
      label: (
        <>
          <FileOutlined /> Documentos
        </>
      ),
      children: renderDocumentsTab(),
    },
    {
      key: 'actions',
      label: (
        <Dropdown
          menu={{ items: accionesItems, onClick: handleOptionsClick }}
          trigger={['click']}
        >
          <span onClick={(e) => e.stopPropagation()}>Acciones ▾</span>
        </Dropdown>
      ),
      children: renderActionsTab(),
    },
  ];

  return (
    <Drawer
      title={
        <Space>
          <span>{title}</span>
          {empleado && <span style={{ fontSize: '12px', color: '#999' }}>#{empleado.nomina_employee_number || id}</span>}
        </Space>
      }
      placement="right"
      onClose={onClose}
      open={open}
      closable={true}
      width="100%"
      height="100%"
      maskClosable={false}
      styles={{
        header: {
          borderBottom: '1px solid #f0f0f0',
        },
        body: {
          padding: 20,
        },
      }}
      extra={[]}
    >
      <Spin spinning={loading}>
        <Card style={{ marginBottom: 16 }}>
          <Row gutter={16} align="middle" justify="space-between">
            <Col>
              <Space size={16}>
                <Upload beforeUpload={beforeFotoUpload} showUploadList={false} accept="image/*" disabled={fotoUploading}>
                  <div style={{ position: 'relative', width: 80, height: 80, borderRadius: 8, overflow: 'hidden', cursor: 'pointer', border: '1px solid #d9d9d9', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fafafa' }}>
                    {empleado?.foto ? (
                      <img src={normalizeFotoSrc(empleado.foto)} alt="foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      <UserOutlined style={{ fontSize: 32, color: '#bfbfbf' }} />
                    )}
                    <div style={{ position: 'absolute', inset: 0, background: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s' }}
                      className="foto-overlay"
                    >
                      <span style={{ fontSize: 11, fontWeight: 600, color: '#595959', textAlign: 'center', lineHeight: 1.2 }}>
                        {fotoUploading ? 'Subiendo...' : 'Cargar imagen'}
                      </span>
                    </div>
                  </div>
                </Upload>
                <div>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>{empleado?.name || 'Empleado'}</div>
                  <div style={{ color: '#8c8c8c' }}>{empleado?.job_title || 'Sin puesto'}</div>
                </div>
              </Space>
            </Col>
            <Col>
              <Space size={8} align="center">
                <Tag color={contractStatus.color === 'green' ? 'green' : 'red'}>{contractStatus.label}</Tag>
                <span style={{ color: '#595959' }}>
                  {contractStatus.status === 'inactive'
                    ? `Contrato finalizado: ${empleado?.nomina_contract_end_date ? dayjs(empleado.nomina_contract_end_date).format('DD/MM/YYYY') : 'N/A'}`
                    : `Contratado desde: ${empleado?.nomina_contract_start_date ? dayjs(empleado.nomina_contract_start_date).format('DD/MM/YYYY') : 'N/A'}`}
                </span>
              </Space>
            </Col>
          </Row>
        </Card>

        <style>{`
          .info-item {
            display: flex;
            flex-direction: column;
            gap: 4px;
            margin-bottom: 12px;
          }
          .info-label {
            font-weight: 600;
            color: #666;
            font-size: 12px;
          }
          .info-value {
            font-size: 14px;
            color: #000;
          }
          .info-card {
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
          }
          .foto-overlay { opacity: 0; }
          .foto-overlay:hover { opacity: 1; }
          .metric-box {
            height: 100%;
            padding: 12px;
            border: 1px solid #f0f0f0;
            border-radius: 8px;
            background: #fafafa;
            display: flex;
            flex-direction: column;
            gap: 4px;
          }
        `}</style>
        <Tabs
          items={tabItems}
          activeKey={activeTab}
          onChange={setActiveTab}
          type="card"
          tabBarGutter={8}
        />
        
      </Spin>
    </Drawer>
  );
};

export default EmpleadoDetail;
